export default __webpack_public_path__ + "static/media/tshirt-s.048d5f10.jpg";